import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Start Checkin")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ACardMeta = _resolveComponent("ACardMeta")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_ACard = _resolveComponent("ACard")!
  const _component_ABadgeRibbon = _resolveComponent("ABadgeRibbon")!

  return (_openBlock(), _createBlock(_component_ABadgeRibbon, {
    text: _ctx.formattedPrice + ' Near'
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ACard, {
        hoverable: "",
        class: "event-card"
      }, {
        cover: _withCtx(() => []),
        actions: _withCtx(() => [
          _createVNode(_component_AButton, { onClick: _ctx.handleSubmit }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            innerHTML: _ctx.item.metadata.media
          }, null, 8, _hoisted_1),
          _createVNode(_component_ACardMeta, {
            title: _ctx.item.metadata.title,
            description: _ctx.item.metadata.description
          }, null, 8, ["title", "description"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["text"]))
}